module.exports = __webpack_public_path__ + "default.aa80b810125c0d39934361955b7df7e7.jpg";